<template>
  <v-card>
    <v-card-title>{{ this.device.nickname }}</v-card-title>
    <v-card-subtitle>{{ this.device.device_name }}</v-card-subtitle>
    <v-card-text>
      <v-row>
        <v-col> SN: {{ this.device.device_sn }} </v-col>
        <v-col> Drone SN: {{ this.device.child_device_sn }} </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="openDevice()" color="primary" variant="elevated" rounded="true" text >Abrir</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
/* eslint-disable */ 
import router from "@/router";
import store from "@/store";
import { ref } from "vue";
import { notify } from "notiwind";
import { useNotify } from '@/application/services-ui/notifyService'

const notifyService = useNotify()

export default {
  props: {
    device: {
      type: Object,
      required: true,
    },
  },
  data: () => ({}),
  setup() {
    const useStore = store();
  
    return {
      store: useStore,
    };
  },
  mounted() { 
    console.log(this.device)
  },
  methods: {
    openDevice() {
      const drone_sn = this.device.child_device_sn;
      if (drone_sn == "" || drone_sn == null || drone_sn == undefined) {
        /*notify(
          {
            group: 'default',
            level: 'warn',
            title: 'MQTT ',
            text: 'Drone no configurado',
          },
          2500 // 2.5s
        )*/
        notifyService.showAlert('DEVICE_NOT_CONFIGURATED')
        return;
      }
      console.log("Open device");
      console.log(this.device)
      const device_type = this.device.domain;
      const path = ref("")
      if (device_type == 3) {
        path.value = "workspace"
      } else {
        path.value = "workspacerc"
      }
      this.store.setDeviceSn(this.device.device_sn);
      this.store.setChildDeviceSn(this.device.child_device_sn);
      this.store.setDevice(this.device);
      localStorage.setItem("device", this.device);
      localStorage.setItem("device_sn", this.device.device_sn);
      localStorage.setItem("child_device_sn", this.device.child_device_sn);
      
      router.push({
        path: path.value,
      });
    },
  },
};
</script>
